import cookie from "js-cookie";
// import { LAUNCH_DARKLY_ID_COOKIE } from "tracking/hooks/useSetLaunchDarklyId"

import { isServer } from "@shared/utils.environment";

const LAUNCH_DARKLY_ID_COOKIE = "bp_ld_id";

// bpLdId (BeautyPie LaunchDarkly Id) is a persistent value stored in the user's cookies
// It enables us to serve a feature flag experience for testing

export const getBpLdId = (): string => {
  if (isServer()) {
    return "SSR";
  }

  let bpLdId = cookie.get(LAUNCH_DARKLY_ID_COOKIE);

  if (!bpLdId) {
    bpLdId = "not-set";
  }

  return bpLdId;
};
